import { SUPER_MINTER_ABI, SUPER_MINTER_ADDRESS } from '../../abi/super-minter.mjs';

async function getMintingSchedules(client, { editionAddress, unixTimestamp = Date.now() / 1e3 }) {
  const schedules = await client.readContract({
    abi: SUPER_MINTER_ABI,
    address: SUPER_MINTER_ADDRESS,
    functionName: "mintInfoList",
    args: [editionAddress]
  }).then(
    (schedules2) => schedules2.map((schedule) => ({
      ...schedule,
      mode: schedule.mode === 0 ? "DEFAULT" : schedule.mode === 1 ? "VERIFY_MERKLE" : "VERIFY_SIGNATURE"
    }))
  );
  const activeSchedules = schedules.filter((mintSchedule) => {
    return mintSchedule.startTime <= unixTimestamp && mintSchedule.endTime > unixTimestamp && !mintSchedule.paused;
  });
  return {
    schedules,
    activeSchedules
  };
}

export { getMintingSchedules };
